<dum-main *ngIf="init" [isAuth]="isAuthenticated" [userLogged]="userLogged">
  <router-outlet></router-outlet>
</dum-main>

